import { LoadablePaint } from '@confluence/loadable';

// Must remain LoadablePaint (not AfterPaint) because the underlying
// PagePropertiesReportRenderer is itself a LoadablePaint component. A
// child loadable cannot have a higher priority than its parent — doing
// so triggers the "Loadables are prioritized incorrectly" SSR error and
// can deadlock the page until timeout.
export const DetailsSummaryExtensionHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-DetailsSummaryExtensionHandler" */ '../src/DetailsSummaryExtensionHandler.tsx'
			)
		).DetailsSummaryExtensionHandler,
});
